import loginModule from '../scripts/login/login.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(loginModule);